"use client";

import { c as _c } from "react/compiler-runtime";
import { useEffect } from "react";
import { setLastUsedProjectAction } from "@/lib/actions/project";
interface LastUsedProjectTrackerProps {
  orgId: string;
  projectId: string;
}

/**
 * Client component that tracks the last used project by calling a Server Action
 */
export function LastUsedProjectTracker(t0) {
  const $ = _c(4);
  const {
    orgId,
    projectId
  } = t0;
  let t1;
  let t2;
  if ($[0] !== orgId || $[1] !== projectId) {
    t1 = () => {
      setLastUsedProjectAction(orgId, projectId).catch(_temp);
    };
    t2 = [orgId, projectId];
    $[0] = orgId;
    $[1] = projectId;
    $[2] = t1;
    $[3] = t2;
  } else {
    t1 = $[2];
    t2 = $[3];
  }
  useEffect(t1, t2);
  return null;
}
function _temp(error) {
  console.error("Failed to set last used project:", error);
}